import React, { useState } from "react";
import dataService from "../../../helpers/dataService";
import tools from "../../../helpers/tools";
import Loader from "../../common/Loader";
import "./AUTOContainer.scss";
import "./devisDemandeEntreprise.scss";

// Bloc devis d'une demande entreprise (RC Pro / Cyber / AC), par établissement.
// Rendu et libellés repris d'AUTORequestCard (volet auto) pour une expérience homogène.
const DevisDemandeEntreprise = ({ company, product }) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [downloadError, setDownloadError] = useState(false);

  const downloadQuote = () => {
    setDownloadError(false);
    setIsDownloading(true);
    const filename = tools.getDocumentName({
      fileExt: "pdf",
      documentName: "Devis",
      productName: product,
      companyName: company.company || undefined,
      uploadedAt: company.quoteUploadedAt,
    });
    dataService.downloadFile(
      `customers/me/company_requests/${company.leadId}/quote`,
      { filename },
      () => {
        window.dataLayer?.push({ event: "telechargment_pdf", nom_pdf: `DEVIS_${product}` });
      },
      () => setDownloadError(true),
      () => setIsDownloading(false)
    );
  };

  if (!company.quoteAvailable || !company.leadId) {
    return (
      <p className="auto-note devis-demande mb-3">
        <i className="fa fa-hourglass-half mr-1" aria-hidden="true" /> Votre devis est en cours de
        préparation.
      </p>
    );
  }

  return (
    <div className="devis-demande mb-3">
      <div className="auto-request-row devis-demande__row">
        <p className="auto-note mb-0">
          Votre devis est prêt. Téléchargez-le, puis contactez votre gestionnaire pour finaliser la
          souscription.
        </p>
        <button
          type="button"
          className="btn btn-primary text-white"
          style={{ minHeight: 44 }}
          onClick={downloadQuote}
          disabled={isDownloading}
        >
          {isDownloading ? (
            <Loader color="#ffffff" size={24} />
          ) : (
            <>
              <i className="fa fa-download mr-2" aria-hidden="true" />
              Télécharger mon devis
            </>
          )}
        </button>
      </div>
      {downloadError && (
        <p
          className="mb-0 mt-2"
          role="status"
          aria-live="polite"
          style={{ color: "#a12013", fontWeight: "bold" }}
        >
          Le téléchargement a échoué. Réessayez dans quelques instants.
        </p>
      )}
    </div>
  );
};

export default DevisDemandeEntreprise;
